﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import ForelopigUttalelseSkjemaSideDto from '../Models/ForelopigUttalelseSkjemaSideDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';

const rootReducer = combineReducers<ForelopigUttalelseSkjemaSideAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    epiContext: (
        state: EpiContext<ForelopigUttalelseSkjemaSideDto> | undefined,
        action: UpdateEpiContextActionTypes<ForelopigUttalelseSkjemaSideDto>,
    ): EpiContext<ForelopigUttalelseSkjemaSideDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
});

export type ForelopigUttalelseSkjemaSideAppState = EpiAppStateMedSteg<ForelopigUttalelseSkjemaSideDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
};

export default function configureStore(): Store<ForelopigUttalelseSkjemaSideAppState> {
    const valgStateJson = window.localStorage.getItem('state');
    if (valgStateJson != null) {
        const savedState = JSON.parse(valgStateJson) as ForelopigUttalelseSkjemaSideAppState;
        return createStore(rootReducer, savedState, applyMiddleware(ReduxThunk));
    }
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
